import { BRAND_NAME } from '../../core/constants';
import { LanguagePicker } from './LanguagePicker';
import * as S from './styled';

interface HeaderProps {
  readonly withLanguagePicker?: boolean;
  readonly screenId?: string;
}

export const Header = ({ withLanguagePicker = false, screenId = '' }: HeaderProps) => (
  <S.HeaderWrapper $withLanguagePicker={withLanguagePicker}>
    <S.Logo />
    <S.Text>{BRAND_NAME}</S.Text>
    {withLanguagePicker && <LanguagePicker screenId={screenId} />}
  </S.HeaderWrapper>
);
